export default function EditProcessSuccessionDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  emDataService
) {
  const vm = this;

  vm.handleClose = _handleClose;
  vm.handleSave = _handleSave;
  vm.handleSuccessorResourceChange = _handleSuccessorResourceChange;

  vm.getAutocompleteItemClass = _getAutocompleteItemClass;

  vm.newProcess = {
    ...vm.process,
    successions: {
      ...vm.process.successions
    },
  };

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSave() {
    loaderService.showViewLoader = true;

    if ($scope.bcpEditProcessSuccessionForm.$invalid) {
      loaderService.showViewLoader = false;
      $scope.bcpEditProcessSuccessionForm.$submitted = false;
      return false;
    }

    if (!checkSuccessionPlanning()) {
      loaderService.showViewLoader = false;
      $scope.bcpEditProcessSuccessionForm.$submitted = false;
      return false;
    }

    loaderService.showViewLoader = true;
    return emDataService.saveProcess(vm.departmentId, vm.process.processId, vm.process.name, vm.newProcess.successions)
      .then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The Process Succession has been saved successfully.');
        // $rootScope.$broadcast('refreshSuccessionPlanProcesses');
        $rootScope.$broadcast('refreshStatuses');
        $rootScope.$broadcast('refreshBCPAssessments');
        _closeDialog();
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('There was an error saving the Process Succession.');
      });
  }

  function _getAutocompleteItemClass(item) {
    if (!item) {
      return '';
    }
    return item.isVendor ? 'vendor' : 'person';
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    vm.primarySuccessorOptions = _getPrimarySuccessors();
    loaderService.showViewLoader = false;
  }

  function _getPrimarySuccessors() {
    return vm.successorOptions.filter(
      item => !item.isVendor
    );
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editProcessSuccessionDialog);
  }

  function checkSuccessionPlanning() {
    if (vm.newProcess.successions.primary) {
      vm.newProcess.successions.primary.planPriority = 1;
    }
    if (vm.newProcess.successions.alternate) {
      vm.newProcess.successions.alternate.planPriority = 2;
    }
    if (vm.newProcess.successions.tertiary) {
      vm.newProcess.successions.tertiary.planPriority = 3;
    }

    // Make sure there is a primary if a secondary is filled out
    if ((vm.newProcess.successions.alternate !== null) && (vm.newProcess.successions.primary === null)) {
      alerts.error('There must be a Primary Resource for an Alternate Resource to be set.');
      return false;
    }

    // Make sure there is a primary and secondary if a tertiary is filled out
    if ((vm.newProcess.successions.tertiary !== null) && ((vm.newProcess.successions.alternate === null)
      || (vm.newProcess.successions.primary === null))) {
      alerts.error('There must be a Primary Resource and Alternate Resource for a Tertiary Resource to be set.');
      return false;
    }

    return true;
  }

  function _handleSuccessorResourceChange(acvm) {
    const item = acvm.selectedItem;
    const position = acvm.position;

    const isPrimaryResource = (vm.newProcess.successions.primary !== undefined) && (vm.newProcess.successions.primary !== null) && (item !== null)
      && (((vm.newProcess.successions.primary.vendorId !== null) && (vm.newProcess.successions.primary.vendorId !== undefined) && (vm.newProcess.successions.primary.vendorId === item.vendorId))
        || ((vm.newProcess.successions.primary.userId !== null) && (vm.newProcess.successions.primary.userId !== undefined) && (vm.newProcess.successions.primary.userId === item.userId)));

    const isSecondaryResource = (vm.newProcess.successions.alternate !== undefined) && (vm.newProcess.successions.alternate !== null) && (item !== null)
      && (((vm.newProcess.successions.alternate.vendorId !== null) && (vm.newProcess.successions.alternate.vendorId !== undefined) && (vm.newProcess.successions.alternate.vendorId === item.vendorId))
        || ((vm.newProcess.successions.alternate.userId !== null) && (vm.newProcess.successions.alternate.userId !== undefined) && (vm.newProcess.successions.alternate.userId === item.userId)));

    const isTertiaryResource = (vm.newProcess.successions.tertiary !== undefined) && (vm.newProcess.successions.tertiary !== null) && (item !== null)
      && (((vm.newProcess.successions.tertiary.vendorId !== null) && (vm.newProcess.successions.tertiary.vendorId !== undefined) && (vm.newProcess.successions.tertiary.vendorId === item.vendorId))
        || ((vm.newProcess.successions.tertiary.userId !== null) && (vm.newProcess.successions.tertiary.userId !== undefined) && (vm.newProcess.successions.tertiary.userId === item.userId)));

    if (position === 'primary') {
      if (isSecondaryResource) {
        alerts.error('The Primary Successor Resource cannot be the same as the Secondary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Primary Successor Resource cannot be the same as the Tertiary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'secondary') {
      if (isPrimaryResource) {
        alerts.error('The Alternate Successor Resource cannot be the same as the Primary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Alternate Successor Resource cannot be the same as the Tertiary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'tertiary') {
      if (isPrimaryResource) {
        alerts.error('The Tertiary Successor Resource cannot be the same as the Primary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isSecondaryResource) {
        alerts.error('The Tertiary Successor Resource cannot be the same as the Secondary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    }
  }
}

EditProcessSuccessionDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'emDataService'
];
